/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RespondFriendRequestResponse
 */
export interface RespondFriendRequestResponse {
    /**
     * 
     * @type {boolean}
     * @memberof RespondFriendRequestResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof RespondFriendRequestResponse
     */
    message: string;
}

/**
 * Check if a given object implements the RespondFriendRequestResponse interface.
 */
export function instanceOfRespondFriendRequestResponse(value: object): value is RespondFriendRequestResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function RespondFriendRequestResponseFromJSON(json: any): RespondFriendRequestResponse {
    return RespondFriendRequestResponseFromJSONTyped(json, false);
}

export function RespondFriendRequestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RespondFriendRequestResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
    };
}

export function RespondFriendRequestResponseToJSON(json: any): RespondFriendRequestResponse {
    return RespondFriendRequestResponseToJSONTyped(json, false);
}

export function RespondFriendRequestResponseToJSONTyped(value?: RespondFriendRequestResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

